import { useEffect, useState } from "react";
import { stateListeners } from "../stateListeners";

const selectedSavedDescriptions: { [key: string]: number[] } = {};

export function useSelectedSavedDescriptions(
  name: string = "selectedSavedDescriptions"
) {
  console.log(
    "useSelectedSavedDescriptions initial state called with name:",
    name,
    selectedSavedDescriptions[name]
  );
  if (!selectedSavedDescriptions[name]) {
    selectedSavedDescriptions[name] = [];
  }

  const [
    internalSelectedSavedDescriptions,
    setInternalSelectedSavedDescriptions,
  ] = useState<number[]>(selectedSavedDescriptions[name] as number[]);

  const listener = stateListeners(
    name,
    selectedSavedDescriptions[name] as number[]
  );

  useEffect(() => {
    const unsubscribe = listener.subscribe<number[]>(
      setInternalSelectedSavedDescriptions
    );
    return () => {
      unsubscribe();
    };
  }, [listener]);

  const setSelectedSavedDescriptions = (
    callback: (prev: number[]) => number[]
  ) => {
    setInternalSelectedSavedDescriptions((desc) => {
      const newState = callback(desc);
      selectedSavedDescriptions[name] = newState; // Update local state
      return listener.sendStateChange(newState);
    });
  };

  return {
    selectedSavedDescriptions: internalSelectedSavedDescriptions,
    setSelectedSavedDescriptions,
  };
}

export function setInitialSelectedSavedDescriptions(
  name: string,
  initialState: number[]
) {
  selectedSavedDescriptions[name] = initialState;
}
